import DictionarySelect from './dictionaryselect.vue';

DictionarySelect.install = function (Vue) {
    Vue.component(DictionarySelect.name, DictionarySelect);
};

export default DictionarySelect;